import React from "react";
import localeText from "../../../../locale";

const OrderDetailsShippingInfoCard = ({ currentOrder }) => {
  if (
    !currentOrder ||
    !(
      (currentOrder.status === "SENT" || currentOrder.status === "RECEIVED") &&
      !currentOrder?.itens?.[0]?.product?.downloadable &&
      !currentOrder?.pickinaddress
    )
  ) {
    return null;
  }

  return (
    <div className="grid mb-4">
      <div className="lg:col-9 col-0" />
      <div className="lg:col-3 col-12">
        <div className="card border-1 border-300">
          <p className="p-2 surface-300 mt-2 mb-0 p-0">
            <b>{localeText("shippingInfo")}:</b>
          </p>
          <hr className="mt-2 p-0" />
          <div className="grid">
            <div className="col-6">
              {localeText("shippingCompany")}: {currentOrder.shippingcompany}
            </div>
          </div>
          <div className="grid">
            <div className="col-6">
              {localeText("trackingObject")}: {currentOrder.trackingobject}
            </div>
          </div>
          <div className="grid">
            <div className="col-6">
              Status:{" "}
              {localeText(currentOrder.status === "SENT" ? "sent" : "received")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsShippingInfoCard;

